import React, { useState } from 'react';
import '../styles/RoomBookingSection.css';

const RoomSearch = () => {
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const [checkIn, setCheckIn] = useState(today);
  const [checkOut, setCheckOut] = useState(tomorrow);
  const [room, setRoom] = useState(1);
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [activeDateField, setActiveDateField] = useState(null);
  const [showGuestPicker, setShowGuestPicker] = useState(false);

  const formatDate = (date) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  };

  const handleIncrement = (type, e) => {
    e.stopPropagation();
    if (type === 'room' && room < 5) setRoom(room + 1);
    if (type === 'adults' && adults < 5) setAdults(adults + 1);
    if (type === 'children' && children < 4) setChildren(children + 1);
  };

  const handleDecrement = (type, e) => {
    e.stopPropagation();
    if (type === 'room' && room > 1) setRoom(room - 1);
    if (type === 'adults' && adults > 1) setAdults(adults - 1);
    if (type === 'children' && children > 0) setChildren(children - 1);
  };

  return (
    <div className="room-search-container">
      <form className="tourmaster-room-search-form">
        {/* Check In */}
        <div className="form-field">
          <div className="tourmaster-head">Check In</div>
          <div 
            className="tourmaster-tail date-field"
            onClick={() => setActiveDateField('checkIn')}
          >
            {formatDate(checkIn)}
            <span className="dropdown-arrow">▼</span>
            {activeDateField === 'checkIn' && (
              <input 
                type="date" 
                className="date-input" 
                value={checkIn.toISOString().split('T')[0]}
                onChange={(e) => {
                  setCheckIn(new Date(e.target.value));
                  setActiveDateField(null);
                }}
                onBlur={() => setActiveDateField(null)}
                autoFocus
              />
            )}
          </div>
        </div>

        {/* Check Out */}
        <div className="form-field">
          <div className="tourmaster-head">Check Out</div>
          <div 
            className="tourmaster-tail date-field"
            onClick={() => setActiveDateField('checkOut')}
          >
            {formatDate(checkOut)}
            <span className="dropdown-arrow">▼</span>
            {activeDateField === 'checkOut' && (
              <input 
                type="date" 
                className="date-input" 
                value={checkOut.toISOString().split('T')[0]}
                onChange={(e) => {
                  setCheckOut(new Date(e.target.value));
                  setActiveDateField(null);
                }}
                min={checkIn.toISOString().split('T')[0]}
                onBlur={() => setActiveDateField(null)}
                autoFocus
              />
            )}
          </div>
        </div>

        {/* Room */}
        <div className="form-field">
          <div className="tourmaster-head">Room</div>
          <div className="tourmaster-tail room-field">
            <span>{room}</span>
            <div className="quantity-selector">
              <button 
                type="button" 
                className="quantity-btn minus" 
                onClick={(e) => handleDecrement('room', e)}
              >
                −
              </button>
              <button 
                type="button" 
                className="quantity-btn plus" 
                onClick={(e) => handleIncrement('room', e)}
              >
                +
              </button>
            </div>
          </div>
        </div>

        {/* Guests - Combined Field */}
        <div className="form-field guests-field">
          <div className="tourmaster-head">Guests</div>
          <div 
            className="tourmaster-tail combined-guests"
            onClick={() => setShowGuestPicker(!showGuestPicker)}
          >
            <span>Adults: {adults}</span>
            <span>Children: {children}</span>
            <span className="dropdown-arrow">▼</span>
            
            {showGuestPicker && (
              <div 
                className="guest-picker-dropdown"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="guest-picker-row">
                  <span>Adults</span>
                  <div className="quantity-selector">
                    <button 
                      type="button" 
                      className="quantity-btn minus" 
                      onClick={(e) => handleDecrement('adults', e)}
                    >
                      −
                    </button>
                    <span className="guest-count">{adults}</span>
                    <button 
                      type="button" 
                      className="quantity-btn plus" 
                      onClick={(e) => handleIncrement('adults', e)}
                    >
                      +
                    </button>
                  </div>
                </div>
                <div className="guest-picker-row">
                  <span>Children</span>
                  <div className="quantity-selector">
                    <button 
                      type="button" 
                      className="quantity-btn minus" 
                      onClick={(e) => handleDecrement('children', e)}
                    >
                      −
                    </button>
                    <span className="guest-count">{children}</span>
                    <button 
                      type="button" 
                      className="quantity-btn plus" 
                      onClick={(e) => handleIncrement('children', e)}
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Submit Button */}
        <button type="submit" className="search-btn">
          Search Room
        </button>
      </form>
    </div>
  );
};

export default RoomSearch;